import classNames from '@utils/classnames';

export interface IToggleProps {
  isEnabled: boolean;
  onChange: (isEnabled: boolean) => void;
  isDisabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

export const Toggle: React.FC<IToggleProps> = (props) => {
  const { isEnabled, onChange, isDisabled, className, ariaLabel } = props;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isEnabled}
      aria-label={ariaLabel}
      onClick={() => onChange(!isEnabled)}
      disabled={isDisabled}
      className={classNames(
        'relative inline-flex h-5 w-[34px] shrink-0 items-center rounded-full transition-colors',
        isEnabled ? 'bg-brand' : 'bg-border-strong',
        isDisabled ? 'cursor-default opacity-50' : 'cursor-pointer',
        className,
      )}
    >
      <span
        className={classNames(
          'inline-block h-3.5 w-3.5 rounded-full bg-white shadow-sm transition-transform',
          isEnabled ? 'translate-x-[17px]' : 'translate-x-[3px]',
        )}
      />
    </button>
  );
};
